import React from 'react'
import Wrapper from './Wrapper'
import { Text, Link } from '@react-pdf/renderer'

export interface TextReadWidgetProps {
    value?: string
    title?: string
    description?: string
    contentType?: 'text' | 'url' | 'email'
    multiline?: boolean
}

const TextReadWidget: React.FC<TextReadWidgetProps> = ({
    value = '',
    title,
    description,
    contentType = 'text',
    multiline
}) => {

    //console.log(title, value, contentType)

    return (
        <Wrapper
            title={title}
            description={description}
            value={value}>
            {((contentType !== 'url' && contentType !== 'email') || multiline) ?
                <Text>
                    {value || '---'}
                </Text>
                :
                <Link
                    src={(contentType === 'email') ? `mailto:${value}` : value}
                    style={{
                        color: 'blue'
                    }}>
                    {value || '---'}
                </Link>
            }
        </Wrapper>
    )
}

export default TextReadWidget
